<template>
  <div>
    <div class="et-enterprise-list-search">
      企业分类：
      <el-radio-group v-model="activevalue" size="small">
        <el-radio-button v-for="item in constant.businessTypes" :key="item.value" :label="item.value">{{item.label}}</el-radio-button>
      </el-radio-group>
      地区：
      <el-cascader size="small" placeholder="请选择地区" :options="regionmodule.regions" filterable change-on-select></el-cascader>
      关键字：
      <el-input size="small" placeholder="请输入公司名或者关键字进行搜索" class="el-width-300"></el-input>
      <el-button size="small" type="primary" icon="el-icon-search">搜索</el-button>
    </div>
    <div class="et-enterprise-list-body">
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="et-enterprise-list fl">
        <div class="logo">
          <img src="http://www.cajay.net/images/logo.png" alt />
        </div>
        <div class="et-enterprise-name">
          <el-tooltip class="item" content="广州凯捷物流供应链有限公司" placement="top">
            <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" tag="span">
              广州凯捷物流供应链有限公司
            </router-link>
          </el-tooltip>
        </div>
        <div class="et-enterprise-content">
          <el-tooltip content="凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。" placement="top">
            <span>凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
              公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
              我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
              凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
              凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。</span>
          </el-tooltip>
        </div>
        <div class="et-enterprise-list-buttom">
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">5-10</span><br />
            <span class="et-enterprise-list-buttom-label">公司规模</span>
          </div>
          <div class="et-enterprise-list-group fl">
            <span class="et-enterprise-list-group-data">20</span><br />
            <span class="et-enterprise-list-buttom-label">产品数量</span>
          </div>
          <div class="et-enterprise-list-group-right fl">
            <span class="et-enterprise-list-group-data">5000</span><br />
            <span class="et-enterprise-list-buttom-label">日出货量</span>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div class="et-enterprise-list-more">
        <span style="cursor: pointer;">加载更多</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activevalue: 1
    }
  },
  methods: {
    linetypeClick (item) {
      this.activevalue = item.value
    }
  }
}
</script>

<style>
.et-enterprise-list-body {
  width: 1290px;
  margin: 20px auto 20px auto;
  min-height: 800px;
}

.et-enterprise-list-search {
  width: 1270px;
  background-color: #ffffff;
  line-height: 100px;
  margin: 20px auto 20px auto;
  text-align: center;
}

.et-enterprise-list-body .et-enterprise-list {
  width: 410px;
  margin: 10px;
  background-color: #ffffff;
}
.et-enterprise-list-body .et-enterprise-list:hover {
  background-color: #dffcff;
}

.et-enterprise-list .logo {
  width: 100%;
  line-height: 100px;
  text-align: center;
  vertical-align: middle;
}
.et-enterprise-list .logo > img {
  max-width: 380px;
  max-height: 100px;
  line-height: 100px;
  text-align: center;
  vertical-align: middle;
}

.et-enterprise-list .et-enterprise-name {
  font-size: 20px;
  width: 100%;
  text-align: center;
  line-height: 30px;
  color: #4b8de3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.et-enterprise-list .et-enterprise-content {
  font-size: 12px;
  width: 95%;
  margin: 10px 10px;
  text-align: center;
  color: #999999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.et-enterprise-list .et-enterprise-list-buttom {
  width: 95%;
  margin: 10px 10px;
  border-top: 2px solid #f2f2f2;
  height: 80px;
  text-align: center;
}

.et-enterprise-list-buttom .et-enterprise-list-group {
  height: 50px;
  margin-top: 20px;
  border-right: 2px solid #f2f2f2;
  width: 32%;
}

.et-enterprise-list-buttom .et-enterprise-list-group-right {
  height: 50px;
  margin-top: 20px;
  width: 30%;
}

.et-enterprise-list-buttom .et-enterprise-list-group-data {
  font-size: 16px;
  font-weight: 700;
}

.et-enterprise-list-buttom .et-enterprise-list-buttom-label {
  font-size: 12px;
  color: #999999;
}

.et-enterprise-list-body .et-enterprise-list-more{
  width: 1270px;
  text-align: center;
  font-size: 16px;
  color: #4b8de3;
  background: #ffffff;
  margin: 10px;
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/enterpriselist.vue